  /*=========================================================================================
                    File Name: globalComponents.js
                    Description: Here you can register components globally
                  ==========================================================================================*/

  import Vue from 'vue';

  import MsButton from './components/msbutton/msButton.vue';
  Vue.component(MsButton.name, MsButton);
  import MsInput from './components/msinput/msInput.vue';
  Vue.component(MsInput.name, MsInput);
  import MsCheckbox from './components/mscheckbox/msCheckbox.vue';
  Vue.component(MsCheckbox.name, MsCheckbox);
  import MsRadio from './components/msradio/msRadio.vue';
  Vue.component(MsRadio.name, MsRadio);
  import MsDatepicker from './components/msdatepicker/MsDatePicker.vue';
  Vue.component(MsDatepicker.name, MsDatepicker);
  import MsTextArea from './components/msTextarea/MsTextArea.vue';
  Vue.component(MsTextArea.name, MsTextArea);

  import MsSwitch from './components/msSwitch/MsSwitch.vue';
  Vue.component(MsSwitch.name, MsSwitch);
  import MsNumber from './components/msnumber/msNumber.vue';
  Vue.component(MsNumber.name, MsNumber);
  import MsDropDown from './components/msdropdown/msDropdown.vue';
  Vue.component(MsDropDown.name, MsDropDown);
  import MsDropdownItem from './components/msdropdown/msDropdownItem.vue';
  Vue.component(MsDropdownItem.name, MsDropdownItem);

  //Ông popup thì sẽ không cấy trực tiếp vào form mà xử lý show động
  import MsPopup from './components/mspopup/MsPopup.vue';
  Vue.component(MsPopup.name, MsPopup);
  import MsComboBox from './components/mscombobox/msCombobox.vue';
  Vue.component(MsComboBox.name, MsComboBox);
  import msGridViewer from '@/components/msgridviewerx/msGridViewer.vue';
  Vue.component(msGridViewer.name, msGridViewer);
  import msConfigLayout from '@/components/ms-config-layout/msConfigLayout.vue';
  Vue.component(msConfigLayout.name, msConfigLayout);
  import msDaterange from '@/components/msdaterange/msDaterange.vue';
  Vue.component(msDaterange.name, msDaterange);
  import msGridEditor from '@/components/msgrideditor/msGridEditor.vue';
  Vue.component(msGridEditor.name, msGridEditor);